import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import {
  Image,
  Keyboard,
  Modal,
  Pressable,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { checkAcApi, checkCode, checkVerifyCode, sendPhoneCode, sendVerifyCode, userDelete } from "../../net/service";
import * as ImSdk from "../../../imsdk/api";
import { closeRealm } from "../../realm";
import {
  Str_AccDelTip,
  Str_AlreadyBoundPhone,
  Str_ApplyDelAcc,
  Str_CodeAlreadySend,
  Str_CodeSendFail,
  Str_Confirm,
  Str_DelAccMsg1,
  Str_DelAccTip1,
  Str_DelAccTip2,
  Str_DelAccTip3,
  Str_DelAccTip4,
  Str_DeleteSucc,
  Str_DelFail,
  Str_Err1015,
  Str_InputCode,
  Str_InputPsd,
  Str_NextStep,
  Str_PsdNotNull,
  Str_ReSend,
  Str_SendCode,
} from "../../language/string_res";
import { hideLoading, showLoading } from "../../components/Loading";
import { useStore } from "../../store/UserStore";
import {
  color_333333,
  color_main,
  white,
  ColorF5F5F5,
} from "../../assets/style/colors";
import { CryptEngine } from "../../utils/CryptEngine";
import { showToast } from "../../components/Toast";
import { getLanguage } from "../../language/i18n";
import { CommonInput } from "../login/CommonInput";
import { showDialog } from "../../components/CommonDialog";
import { getVcode } from "../../store/token";
import DelIcon from "../../assets/svg/icon_account_del.svg";
import { BottomButtonView } from "../../components/BottomButtonView";
import { MainNavProps } from "../navigation/main/MainParamList";
import { ScreenCloseModal, ScreenModal } from "../../components/ScreenModal";
import { BehavioralVerifyModal } from "../login/BehavioralVerifyModal";
import { Logout } from "../Mine/MineScreen";
const DelAccModal = ({
  vis,
  close,
  done,
}: {
  vis: boolean;
  close: () => void;
  done: () => void;
}) => {
  const { state } = useStore();
  const phone = state?.user.telno || state?.user.rtel || "";
  const [psd, setPsd] = useState("");
  const [code, setCode] = useState("");
  const isNeedCode = phone && phone.length > 0;
  const language = getLanguage();
  const [sendText, setSendText] = useState(Str_SendCode);
  const [running, setRunning] = useState(false);
  let timer: any;
  let endTime: number = 0;

  const [isVerifyModalShow, setIsVerifyModalShow] = useState(false)
  const captchaToken = useRef<string>("")
  const eventTagRef = useRef("")

  function startTime() {
    endTime = Date.now() + 60 * 1000;
    setRunning(true);
    updateRemain();
  }
  function updateRemain() {
    cancelAnimationFrame(timer);
    const tick = () => {
      const left = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      // setRemainTime(left);
      setSendText(`${left}s`)
      if (left > 0) {
        timer = requestAnimationFrame(tick);
      } else {
        reset();
      }
    };

    tick();
  }
  function reset() {
    cancelAnimationFrame(timer);
    // setRemainTime(0);
    setSendText(Str_ReSend)
    setRunning(false);
  }



  const onSendCodeBehavioralVerifySuccess = async (isSuccess: boolean, token: string) => {
    // 验证未通过
    if (isSuccess !== true) {
      return
    }

    // 记录验证码token
    captchaToken.current = token
    // 检查账号并且发送验证码
    checkAccountAndSendCode(phone, '13')
  }

  const sendCode = () => {
    if (running) {
      return;
    }

    setIsVerifyModalShow(true)
  }

  // 检查账号并且发送验证码
  function checkAccountAndSendCode(acc: string, send_type: string) {
    const vcode = getVcode()
    // 先校验账号,获取EventTag
    checkAcApi({ account: acc, vcode: vcode, lang: language }).then((res) => {
      if (res.code !== 0) {
        showToast(res.msg ?? '')
        reset()
        return
      }

      // 存在
      const eventTag = res.data.eventTag
      eventTagRef.current = eventTag
      startTime()
      // 发送手机验证码
      sendVerifyCode({
        send_type: send_type,
        eventTag: eventTag,
        lang: language,
        vcode: vcode,
        captchaToken: captchaToken.current,
        byEmail: false
      }).then(res => {
        if (res.code === 0) {
          showToast(Str_CodeAlreadySend)
        } else {
          showToast(res.msg || Str_CodeSendFail)
          reset()
        }
      })
    }).catch((res) => {
      showToast(res.msg || Str_CodeSendFail)
      reset()
    })
  }

  function delAccount(psd: string, sms_token?: string) {
    const md5Psd = CryptEngine.md5(psd.trim())
    userDelete(md5Psd, sms_token).then((res) => {
      if (res.code === 0) {
        closeRealm();
    // showToast(res.msg || Str_DeleteSucc)
        done()
      } else {
        showToast(res.msg || Str_DelFail)
      }

    }).finally(() => {
      hideLoading()
    })
  }


  const check = () => {
    if (psd && psd.length <= 0) {
      showToast(Str_PsdNotNull)
      return
    }
    showLoading("")
    if (isNeedCode) {
      verifyCode()
    } else {
      delAccount(psd)
    }

  }

  /**
       * 验证短信验证码
       */
  const verifyCode = () => {
    const vcode = getVcode()
    const body = {
      send_type: '13',
      vcode: vcode,
      code: code,
      lang: language,
      eventTag: eventTagRef.current,
      byEmail: false
    }
    checkVerifyCode(body).then((res) => {
      console.log("verifyCode res:", res)
      if (res.code === 0 && res.data && res.data.otp_token) {
        const token = res.data?.otp_token ?? ""
        delAccount(psd, token)
      } else {
        hideLoading()
        showToast(res.msg ?? Str_Err1015)
      }
    })
  }

  return (
    <Modal
      animationType="fade"
      transparent={true}
      statusBarTranslucent={true}
      onRequestClose={close}
      visible={vis}
    >
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0,0,0,0.5)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View
          style={styles.modalContainer}
        >
          <Text
            style={{
              fontSize: 18,
              fontWeight: "bold",
              paddingVertical: 12,
              fontFamily: "",
              color: "black",
              textAlign: "center",
            }}
          >
            {Str_ApplyDelAcc}
          </Text>
          {isNeedCode && (
            <View
              style={{
                marginTop: 12,
                flexDirection: 'column',
                alignItems: "center",
                width: "100%",
              }}
            >
              <Text style={{ fontSize: 16, color: color_333333 }}>
                {Str_AlreadyBoundPhone}:{phone}
              </Text>
            </View>
          )}
          <CommonInput
            style={{ marginTop: 12 }}
            placeholder={Str_InputPsd}
            text={psd}
            source={require("../../assets/image/icon_psd.png")}
            imgStyle={{ marginRight: 6 }}
            onChangeText={setPsd}
            secureTextEntry={true}
          />
          {isNeedCode && (
            <CommonInput
              style={{ marginTop: 12 }}
              placeholder={Str_InputCode}
              text={code}
              source={require("../../assets/image/icon_psd.png")}
              imgStyle={{ marginRight: 6 }}
              onChangeText={setCode}
              sendText={sendText}
              sendCode={sendCode}
            />
          )}
          <BottomButtonView
            text={Str_Confirm}
            style={{ position: "absolute", bottom: 0, start: 0, end: 0 }}
            onClick={check}
          />
          {/* 右侧关闭按钮 */}
          <Pressable onPress={close} style={styles.closeButton}>
            <Text style={styles.closeText}>×</Text>
          </Pressable>
        </View>

        <BehavioralVerifyModal
          visible={isVerifyModalShow}
          onResult={(isSuccess, token) => {
            setIsVerifyModalShow(false)
            onSendCodeBehavioralVerifySuccess(isSuccess, token)
          }}
        />
      </View>
    </Modal>
  );
};

export const AskAccountDel = ({
  navigation,
}: MainNavProps<"AskAccountDel">) => {
  const [vis, setVis] = useState(false);

  function delAccount() {
    showDialog({
      message: Str_AccDelTip,
      onConfirm: () => {
        dismissModal();
        onConfirm();
      },
    });
  }

  const onConfirm = async () => {
    const authsResult = await ImSdk.getInstance().getAuths();
    if (authsResult.error === undefined && authsResult.auths && authsResult.auths.length) {
      if (authsResult.auths.length >= 2) {
        Logout(false);
        return;
      }
    }

    ImSdk.getInstance().global_emit("global_logout", {});
  }

  const dismissModal = () => {
    setVis(false);
  };
  return (
    <ScreenCloseModal title={Str_ApplyDelAcc} forbidMaskClose={true}>
      <View
        style={{
          backgroundColor: "white",
          borderRadius: 20,
          padding: 32,
          minHeight: 500,
        }}
      >
        <View style={{ alignItems: "center", marginTop: 30 }}>
          <DelIcon width={60} height={60} />
          <Text
            style={{
              color: "black",
              fontSize: 18,
              fontWeight: "bold",
              fontFamily: "",
              marginTop: 24,
              textAlign: "center",
              paddingHorizontal: 60,
              lineHeight: 26,
            }}
          >
            {Str_DelAccMsg1}
          </Text>
        </View>
        <View style={styles.container}>
          <Text style={styles.text}>{Str_DelAccTip1}</Text>
          <Text style={styles.text}>{Str_DelAccTip2}</Text>
          <Text style={styles.text}>{Str_DelAccTip3}</Text>
          <Text style={styles.text}>{Str_DelAccTip4}</Text>
        </View>

        <View
          style={{ marginTop: 60, alignItems: "center", paddingBottom: 20 }}
        >
          <Pressable
            onPress={() => setVis(true)}
            style={{
              backgroundColor: color_main,
              borderRadius: 12,
              paddingVertical: 16,
              paddingHorizontal: 60,
              minWidth: 200,
              maxWidth: 300,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                color: white,
                fontSize: 16,
                fontWeight: "600",
              }}
            >
              {Str_NextStep}
            </Text>
          </Pressable>
        </View>
      </View>
      <DelAccModal vis={vis} close={dismissModal} done={delAccount} />
    </ScreenCloseModal>
  );
};
const styles = StyleSheet.create({
  container: {
    marginHorizontal: 32,
    marginTop: 48,
  },
  text: {
    fontSize: 16,
    color: "#888888",
    paddingVertical: 12,
    lineHeight: 24,
  },
  modalContainer: {
    height: "60%",
    borderRadius: 12,
    overflow: "hidden",
    width: "50%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: white,
    paddingHorizontal: 16,
  },
  closeButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 12,
    right: 16,
  },
  closeText: {
    fontSize: 24,
    color: color_333333,
    fontWeight: "300",
    lineHeight: 28,
  },
});
